import axios from './request'
const URL = {
  invoiceMailing: { // 发票邮寄查询
    retrieve: '/CONTINUTIY-SERVICE/invoice/queryInvoice.magpie'
  },
  customerEscrowSugar: { // 代管糖
    retrieve: '/CONTINUTIY-SERVICE/productLine/queryEscrowSugar.magpie'
  }
}
class OtherInquiry {
  /**
   * retrieve for invoiceMailing 发票邮寄查询
   */
  invoiceMailing (params) {
    const url = URL.invoiceMailing.retrieve

    return axios.post(url, params)
  }
  /**
   * retrieve for customerEscrowSugar 代管糖
   */
  customerEscrowSugar (params) {
    const url = URL.customerEscrowSugar.retrieve

    return axios.post(url, params)
  }
}
export default new OtherInquiry()
